import * as msal from "@azure/msal-browser";
import getEnvironment from "./env";

export const msalConfig = {
    auth: {
        clientId: getEnvironment().clientId,
        authority: getEnvironment().authority,
        postLogoutRedirectUri: window.location.origin + "/",
        redirectUri: window.location.origin + "/",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        // TODO: Decide if we should use sessionStorage (default) or localStorage here
        // localStorage seems to work better for our use case
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

// Export MSAL instance
export default msalInstance;
